module.exports = __webpack_public_path__ + "img/DIYEditorHover.632bec48.png";